/** @jsx jsx */
import { type SerializedStyles, css, jsx } from '@emotion/react';

import * as React from 'react';

import config from 'js/app/config';

import { Link } from '@coursera/event-pulse/react';

import { useEventingProductData } from 'bundles/unified-description-page-common/contexts/EventingContext';

const styles = {
  skillsLinkTag: css`
    display: inline-flex;
    align-items: center;
    border: 1px solid;
    border-radius: 4px;
    padding: 0 var(--cds-spacing-100);
    background-color: var(--cds-color-neutral-disabled);
    border-color: var(--cds-color-neutral-disabled);
    box-shadow: none;
  `,
  skillsLink: css`
    color: var(--cds-color-neutral-primary);

    &:visited:not(.cds-link-focusVisible),
    &:visited,
    &:hover {
      color: var(--cds-color-neutral-primary);
    }
  `,
};

type Props = {
  skill: string;
  cssOverrides?: SerializedStyles;
};

const SkillsTag = ({ skill, cssOverrides }: Props) => {
  const encodedSkill = encodeURIComponent(skill.toLowerCase());
  const href = `${config.url.base}courses?query=${encodedSkill}`;
  const eventingProductData = useEventingProductData();

  return (
    <span css={cssOverrides}>
      <span css={[styles.skillsLinkTag, cssOverrides]}>
        <Link
          variant="quiet"
          typographyVariant="bodySecondary"
          css={styles.skillsLink}
          href={href}
          trackingData={{
            button: { name: 'description_page_skill' },
            pageSection: {
              sectionName: 'about',
            },
            ...eventingProductData,
          }}
        >
          {skill}
        </Link>
      </span>
    </span>
  );
};

export default SkillsTag;
